import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-valide-inv',
  templateUrl: './valide-inv.component.html',
  styleUrls: ['./valide-inv.component.scss']
})
export class ValideInvComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
